//CUSTOMIZE FOR COMMING SOON PRODUCT
$(document).ready(function() {
  $('.select-with-style[data-for="SingleOptionSelector-1"] .select-options li').click(function(e){
    $('#AddToCartForm-product').attr('data-selected', 'true');
    $('.f_addToCart').removeClass('f_addToCart');
    $('.size-error').hide();
    $('.validate-selected-variant').removeClass('active');
  });

  $('#AddToCart-product').click(function(e){
    var form = $('#AddToCartForm-product');
    var select = form.attr('data-selected');
    if(select == 'false'){
    $('.size-error').show();
    e.preventDefault();
    return false;
    }    
  });
  $('body').on('click','.boost-pfs-search-suggestion-header-view-all a',function () {
    $('.close-mb-search').click()
  })
});
//END CUSTOMIZE FOR COMMING SOON PRODUCT

//CURRENCY MOBILE
jQuery(document).ready(function(){
  $('li.parent.currency > a.nav-link').click(function(e){
    e.preventDefault();
  });

  $('li.parent.currency a.currency-item').click(function(e){
    var val = $(this).data('value');
    $('form#currency_form .currency_switcher').val(val).trigger('click');
    $('form#currency_form').submit();
    e.preventDefault();
  });

});
//END CURRENCY MOBILE



function Popup(id) {
  if (!jQuery(id).hasClass('open-popup')) {
    jQuery(id).addClass('open-popup');
    jQuery('body').addClass('has-popup');
  }
}
function closePopup(id) {
  if (jQuery(id).hasClass('open-popup')) {
    jQuery(id).removeClass('open-popup');
    jQuery('body').removeClass('has-popup');
  }
}
jQuery(document).mouseup(function (e) {
     var popup = jQuery(".popup-content");
     if (!popup.is(e.target) && popup.has(e.target).length == 0) {
         jQuery(".popup-wrapper").removeClass('open-popup');
         jQuery('body').removeClass('has-popup');
     }

     var popup2 = jQuery(".sidebar-content");
     if (!popup2.is(e.target) && popup2.has(e.target).length == 0) {
         jQuery(".collection-filters").removeClass('open');
         jQuery('body').removeClass('open-filter');
     }
 });
 function quickViewLoad(url, el, comming_soon, anine_bing){   
   jQuery("#resultLoading").show();
   jQuery.ajax({
     url: url,
     dataType: "html",
     type: "GET",
     success: function(data) {
       jQuery.magnificPopup.open({
         items: {
           src: '<div class="popup-quick-view anine-bing-'+ anine_bing +' comming-soon-'+comming_soon+'">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
           type: 'inline'
         },
         mainClass: 'mfp-move-from-top',
         removalDelay: 500, //delay removal by X to allow out-animation
         callbacks: {
           open: function() {
             jQuery("#resultLoading").hide();
             QVselectOptions();
             QVchangeOptions();
             quickviewSlider();
             QVselectonLoad();
           },
           close: function() {
             jQuery(".popup-quick-view").empty()
           }
         },
       });
     },
     complete: function() {
       el.removeClass("loading");
     },
     error: function() {
       console.log("Quick view error");
     }
   })
}
function selectonLoad() {
  var anine_bing = false;
  if($('.product-page .product-single').hasClass('anine-bing-true')){
    var anine_bing = true; 
  }
  $('.select-with-style .current-select-value').each(function(){
    var productOptionsWrapper = $(this).closest('form[action="/cart/add"]');
    if (productOptionsWrapper.find('.selector-wrapper').size() == 2) {
    if ($(this).closest('.select-with-style').attr('data-for') == 'SingleOptionSelector-0') {
      var currentOption = $(this).text().trim();
      productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
        var arr =  $(this).text().trim().split(' / ');
        var lastIndex = arr.length - 1;
        var lastOption = arr[lastIndex].trim();
        var firstOption = arr[0].trim();
        var disabled = $(this).attr('disabled');
        var qty = $(this).attr('data-quantity');
        var qty_label ='item';
        
        if(anine_bing){
          if(qty < 3){ 
            qty_label ="low-Stock";
          }
        } else{
          if(qty == 1){
            qty_label ="low-Stock";
          }       
        }

        if (firstOption == currentOption) {
          $('.select-with-style[data-for="SingleOptionSelector-1"] .select-options li').each(function() {
            if ($(this).text() == lastOption) {
              $(this).attr('disabled', disabled);
              $(this).addClass(qty_label);
            }
          });
        }
      });
    }
  }
  });
}
function QVselectonLoad() {
  var anine_bing = false;
  if($('.popup-quick-view').hasClass('anine-bing-true')){
    var anine_bing = true;
  }
  $('.popup-quick-view .select-with-style .current-select-value').each(function(){
    var productOptionsWrapper = $(this).closest('form[action="/cart/add"]');
    if (productOptionsWrapper.find('.selector-wrapper').size() == 2) {
    if ($(this).closest('.select-with-style').attr('data-for') == 'SingleOptionSelector-0') {
      var currentOption = $(this).text().trim();
      productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
        var arr =  $(this).text().trim().split(' / ');
        var lastIndex = arr.length - 1;
        var lastOption = arr[lastIndex].trim();
        var firstOption = arr[0].trim();
        var disabled = $(this).attr('disabled');
        var qty = $(this).attr('data-quantity');
        var qty_label ='item';
        if(anine_bing){
          if(qty < 3){
            qty_label ="low-Stock";
          }
        } else{
        if(qty == 1){
          qty_label ="low-Stock";
          }       
        }
        if (firstOption == currentOption) {
          $('.popup-quick-view .select-with-style[data-for="SingleOptionSelector-1"] .select-options li').each(function() {
            if ($(this).text() == lastOption) {
              $(this).attr('disabled', disabled);
              $(this).addClass(qty_label);
            }
          });
        }
      });
    }
  }
  });
}
function selectOptions(){
  var anine_bing = false;
  if($('.product-page .product-single').hasClass('anine-bing-true')){
    var anine_bing = true;
  }
  $('.select-with-style .select-options li').click(function() {
    var productOptionsWrapper = $(this).closest('form[action="/cart/add"]');
    if (productOptionsWrapper.find('.selector-wrapper').size() == 2) {
      if ($(this).closest('.select-with-style').attr('data-for') == 'SingleOptionSelector-0') {
        var currentOption = $(this).text();
        $('.select-with-style[data-for="SingleOptionSelector-1"] .select-options li').removeAttr('disabled').removeClass();
        productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
          var arr =  $(this).text().trim().split(' / ');
          var lastIndex = arr.length - 1;
          var lastOption = arr[lastIndex];
          var firstOption = arr[0];
          var disabled = $(this).attr('disabled');
          var qty = $(this).attr('data-quantity');
          var qty_label ='item';
          if(anine_bing){
            if(qty < 3){
              qty_label ="low-Stock";
            }
          } else{
          if(qty == 1){
            qty_label ="low-Stock";
            }     
          }
          if (firstOption == currentOption) {
            $('.select-with-style[data-for="SingleOptionSelector-1"] .select-options li').each(function() {
              if ($(this).text() == lastOption) {
                $(this).attr('disabled', disabled);
                $(this).addClass(qty_label);
              }
            });
          }
        });
      }
    }
    var optionValue = $(this).data('value');
    var optionText = $(this).text();
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).parent().parent().prev().val(optionValue).change();
    $(this).parent().prev().text(optionText).attr('data-value', optionValue).toggleClass('open');
    $(this).parent().prev().prev().toggleClass('open');
    $(this).parent().toggle();
    var masterValue = '';
    productOptionsWrapper.find('.selector-wrapper select').each(function() {
      if (masterValue != '') {
        masterValue += ' / ';
      }
      masterValue += $(this).val();
    });
    productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
      var option = $(this);
      if (option.text().trim() == masterValue) {
        option.parent().val(option.val()).change();
        var price = option.data('price');
        if (price) {
          option.closest('.productinfo-product').find('.product__price > .money:first-child span').text(Shopify.formatMoney(price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
        }
      }
    });
    if($(this).closest('form').hasClass('product-form-product-pre-order-template')){
      var pre_selected_variant = $('#ProductSelect-product-pre-order-template option:selected').attr('disabled');
      if( pre_selected_variant !== undefined){
        $(this).closest('form').find('button#AddToCart-product-pre-order-template').addClass('disabled').prop( "disabled", true ); 
      }else{
        $(this).closest('form').find('button#AddToCart-product-pre-order-template').removeClass('disabled').prop( "disabled", false );
      }
    }  
  });
}
function QVselectOptions(){
  var anine_bing = false;  
  if($('.popup-quick-view').hasClass('anine-bing-true')){
    var anine_bing = true;
  }
  $('.popup-quick-view .select-with-style .select-options li').click(function() {
    var productOptionsWrapper = $(this).closest('form[action="/cart/add"]');
    if (productOptionsWrapper.find('.selector-wrapper').size() == 2) {
      if ($(this).closest('.select-with-style').attr('data-for') == 'SingleOptionSelector-0') {
        var currentOption = $(this).text();
        $('.popup-quick-view .select-with-style[data-for="SingleOptionSelector-1"] .select-options li').removeAttr('disabled').removeClass();
        productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
          var arr =  $(this).text().trim().split(' / ');
          var lastIndex = arr.length - 1;
          var lastOption = arr[lastIndex];
          var firstOption = arr[0];
          var disabled = $(this).attr('disabled');
          var qty = $(this).attr('data-quantity');
          var qty_label ='item';
          if(anine_bing){
            if(qty < 3){
              qty_label ="low-Stock";
            }
          } else{
          if(qty == 1){
            qty_label ="low-Stock";
            }     
          }
          if (firstOption == currentOption) {
            $('.popup-quick-view .select-with-style[data-for="SingleOptionSelector-1"] .select-options li').each(function() {
              if ($(this).text() == lastOption) {
                $(this).attr('disabled', disabled);
                $(this).addClass(qty_label);
              }
            });
          }
        });
      }
    }
    var optionValue = $(this).data('value');
    var optionText = $(this).text();
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).parent().parent().prev().val(optionValue).change();
    $(this).parent().prev().text(optionText).attr('data-value', optionValue).toggleClass('open');
    $(this).parent().prev().prev().toggleClass('open');
    $(this).parent().toggle();
    var masterValue = '';
    productOptionsWrapper.find('.selector-wrapper select').each(function() {
      if (masterValue != '') {
        masterValue += ' / ';
      }
      masterValue += $(this).val();
    });
    productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
      var option = $(this);
      if (option.text().trim() == masterValue) {
        option.parent().val(option.val()).change();
        var price = option.data('price');
        if (price) {
          // hotfix for CDSD-26016 - true sets formatMoney to forcefully convert cents to dollars
          const convertedPrice = Shopify.formatMoney(price, theme.moneyFormat, true).replace(/((\,00)|(\.00))$/g, '')
          option.closest('.productinfo-product').find('.product__price > .money:first-child span').text(convertedPrice);
        }
      }
    });
    var attr_disable = $(this).attr('disabled');
    if (typeof attr_disable !== typeof undefined && attr_disable !== false) {
      $('.popup-quick-view .add-to-cart__wrapper #AddToCart-product').addClass('disabled').prop( "disabled", true );
      $('.popup-quick-view .add-to-cart__wrapper #AddToCart-product #AddToCartText-product').html('SOLD OUT');
      $('.popup-quick-view.comming-soon-true .add-to-cart__wrapper #AddToCart-product #AddToCartText-product').html('COMING SOON');
    } else{
      $('.popup-quick-view .add-to-cart__wrapper #AddToCart-product').removeClass('disabled').prop( "disabled", false );
      $('.popup-quick-view .add-to-cart__wrapper #AddToCart-product #AddToCartText-product').html('ADD TO BAG');
    }
  });
}
function changeOptions(){
  $('.select-with-style .current-select-value').click(function() {
    $('.select-with-style .current-select-value').not(this).each(function(){
      if($(this).hasClass('open')){
        $(this).toggleClass('open');
        $(this).prev().toggleClass('open');
        $(this).next().toggle();
      }
    });
    $(this).toggleClass('open');
    $(this).prev().toggleClass('open');
    $(this).next().toggle();
  });
}

function QVchangeOptions(){
  $('.popup-quick-view .select-with-style .current-select-value').click(function() {
    $('.popup-quick-view .select-with-style .current-select-value').not(this).each(function(){
      if($(this).hasClass('open')){
        $(this).toggleClass('open');
        $(this).prev().toggleClass('open');
        $(this).next().toggle();
      }
    });
    $(this).toggleClass('open');
    $(this).prev().toggleClass('open');
    $(this).next().toggle();
  });
}
function quickviewSlider(){
  $('.popup-quick-view .product-single__photos').on('init', function(event, slick, direction){
    $(window).trigger('resize');
  });
  jQuery('.popup-quick-view .product-single__photos').slick({
  });
}
jQuery(document).ready(function($){
   $(document).on("click", ".quickview-btn", function(e) {
     e.preventDefault();
     var url = $(this).attr("href"),
         comming_soon = $(this).data("comming-soon"),
         anine_bing = $(this).data("anine-bing"),
         item = $(this);
     quickViewLoad(url, item, comming_soon, anine_bing);
   })

   $('#toggleFilters').click(function(){
     $('body').addClass('open-filter');
     $('#collectionFilters').addClass('open');
   });

   $('.close-sidebar').click(function(){
     $('body').removeClass('open-filter');
     $('#collectionFilters').removeClass('open');
   });

   $('.collection-filters h5').click(function(){
     if ($(this).parent().hasClass('show')) { 
       $('.filter-item').removeClass('show');
     }
     else{
       $('.filter-item').removeClass('show');
       $(this).parent().addClass('show')
     }
   })

	$(window).on("load",function(){
        $(".collection-nav").mCustomScrollbar();
    });

	var $window = $(window);
    var $pane = $('#pane1');
    function checkWidth() {
        var windowsize = $window.width();
        if (windowsize < 770) {
			$(window).on("load",function(){
				//$(".subcate-mobile").mCustomScrollbar();
			});
        }
    }
    checkWidth();
    $(window).resize(checkWidth);


	$('.nav--mobile .nav-carat').click(function(){
		if($('.nav--mobile .main-menu li.parent').hasClass('show')){
			$('.nav--mobile .main-menu li.parent').removeClass('show');
		}
		$(this).parent().toggleClass('show');
	})

    selectOptions();
    changeOptions();
    selectonLoad();

    $(document).mouseup(function(e) {
      var container = $('.select-with-style');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.select-with-style .select-with-style-label.open').removeClass('open');
        $('.select-with-style .current-select-value.open').removeClass('open');
        $('.select-with-style .select-options').hide();
      }
    });

    $('.product__related .grid-uniform').owlCarousel({
        nav:false,
        dots: false,
        responsive:{
            0:{
                items:2,
                dots:true
            },
            600:{
                items:2,
                dots:true
            },
            1000:{
                items:4
            }
        }
    })
});
